/**
 * storage.ts — localStorage 收藏工具
 *
 * MVP 阶段收藏不需要登录，数据只保存在当前浏览器本地。
 * 所有读写都做 try/catch，隐私模式或存储满时静默降级。
 */
import type { Prompt } from '../data/seed';

const FAVORITES_KEY = 'prompt-hub:favorites';

/** 读取收藏 id 列表 */
function readIds(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
}

/** 写回收藏 id 列表 */
function writeIds(ids: string[]): void {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids));
  } catch {
    // 隐私模式或配额不足时静默失败
  }
}

/** 是否已收藏 */
export function isFavorite(id: string): boolean {
  return readIds().includes(id);
}

/**
 * 切换收藏状态，返回切换后的状态（true = 已收藏）
 */
export function toggleFavorite(id: string): boolean {
  const ids = readIds();
  const index = ids.indexOf(id);
  if (index >= 0) {
    ids.splice(index, 1);
    writeIds(ids);
    return false;
  }
  ids.push(id);
  writeIds(ids);
  return true;
}

/** 获取全部收藏 id */
export function getFavoriteIds(): string[] {
  return readIds();
}

/** 从给定 Prompt 列表中筛出已收藏的 */
export function getFavoritePrompts(prompts: Prompt[]): Prompt[] {
  const ids = new Set(readIds());
  return prompts.filter((p) => ids.has(p.id));
}

/** 收藏数量 */
export function getFavoriteCount(): number {
  return readIds().length;
}
